export class DemandCommand {
    public occ!: number;
    public tipoOrganismoOIJ!: number;
    public oij!: number;
    public idPromovente!: number;
    public promovente!: string;
    public fecEnvio!: string;
    public existeEE!: boolean;
    public urlEE!: string;
    public guid!: string;
    public token!: string;
}


   
